<div class="time-marker" *ngIf="displayTimeMarker">
  <span class="time-handle left"></span>
  <span class="time-marker-line"></span>
  <span class="time-handle right"></span>
</div>
